module.exports = __webpack_public_path__ + "static/media/mb-bg-fb-24.ac51ec44.webp";